import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const MarketingDisbursementRoutes = defineRoute({
    record: {
        route: {
            path: "/marketing-disbursement",
            component: () => loadView(import("./MarketingDisbursementTable.vue")),
        },
    },
    create: {
        route: {
            path: "/marketing-disbursement/create",
            component: () => loadView(import("./MarketingDisbursementCreate.vue")),
        },
    },
    detail: {
        route: {
            path: "/marketing-disbursement/detail/:id",
            component: () => loadView(import("./MarketingDisbursementDetail.vue")),
        },
        build(id: string) {
            return `/marketing-disbursement/detail/${id}`;
        },
    },
});
